import { RegistrationOptionCard } from '@/components/molecules';

export const TeamRegistrationOptions = () => {
	const options = [
		{
			title: 'Captain Registration',
			description: 'You are the captain and need to register a team',
			buttonText: 'Register'
		},
		{
			title: 'Join a team',
			description: 'Use your team invitation code to join a team',
			buttonText: 'Join'
		},
		{
			title: 'Free Agent Registration',
			description: 'You don’t have a team, but you want to be placed on one or request to be on a specific team',
			buttonText: 'Register'
		}
	];
	return (
		<div className="flex flex-col gap-9 rounded-xl bg-white px-4 pb-10 pt-4 shadow-sm sm:px-10 sm:pl-8 sm:pt-10 lg:p-10">
			{options.map((option, index) => (
				<RegistrationOptionCard key={index} title={option.title} description={option.description} buttonText={option.buttonText} />
			))}
		</div>
	);
};
